import React from 'react';
import { SkeletonCircleMain, SkeletonWrapper } from './skeleton.Styled';

interface SkeletonCircleType {
  size?: 'sm' | 'md' | 'lg' | 'table';
  shape?: 'square' | 'rounded' | 'circle';
  className?: string;
  containerClassName?: string;
  id?: string;
}

const SkeletonCircle = ({
  size = 'table',
  shape = 'rounded',
  className,
  containerClassName,
  id
}: SkeletonCircleType): JSX.Element => {
  return (
    <SkeletonWrapper className={containerClassName} id={id}>
      <SkeletonCircleMain size={size} shape={shape} className={className} />
    </SkeletonWrapper>
  );
};

export default SkeletonCircle;
